import { render, staticRenderFns } from "./ZoneShow.vue?vue&type=template&id=67b0349d&scoped=true"
import script from "./ZoneShow.vue?vue&type=script&lang=js"
export * from "./ZoneShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b0349d",
  null
  
)

export default component.exports